import axios from 'axios'
import { GetBannerRequest, GetGroupResponse, PwaGeneralSettingQry, PwaGeneralSettingCmd, AboutUsRequest, GetTermAndConditionResponse, TermAndConditionRequest, UploadBannerRequest, PwaCardQry, PwaCardSaveRequest } from '../models';
import { ListResponse, Response } from 'setup/axios/HttpResponse';
import { API_URL } from 'app/utils/common/constants';

const SettingApi = {
  getBanner(): Promise<ListResponse<any>> {
    const url = `${API_URL}/api/v1/pwa/banners`
    return axios.get(url)
  },
  getListGroup(params: GetBannerRequest): Promise<ListResponse<GetGroupResponse>> {
    const url = `${API_URL}/api/v1/service-group/get-service-group-detail`
    return axios.post(url, params)
  },

  // PWA General Setting APIs
  getPwaGeneralSetting(): Promise<Response<PwaGeneralSettingQry>> {
    const url = `${API_URL}/api/v1/pwa-general-setting/get-item`
    return axios.get(url)
  },

  savePwaGeneralSetting(payload: PwaGeneralSettingCmd): Promise<Response<boolean>> {
    const url = `${API_URL}/api/v1/pwa-general-setting/save`

    // Convert to FormData since backend expects IFormFile Image
    const formData = new FormData()

    // Add basic fields
    formData.append('Id', String(payload.id))
    formData.append('CompanyId', payload.companyId)
    formData.append('Color', payload.color)
    formData.append('EmailContract', payload.emailContract)
    formData.append('MobileContract', payload.mobileContract)
    formData.append('IsShowNationlId', String(payload.isShowNationlId))

    // Add image file if exists
    if (payload.image) {
      formData.append('Image', payload.image)
    }

    // Add icon file if exists
    if (payload.icon) {
      formData.append('Icon', payload.icon)
    }

    // Add weekly working hours
    payload.weeklyWorking.forEach((shift, index) => {
      formData.append(`WeeklyWorking[${index}].Id`, String(shift.id))
      formData.append(`WeeklyWorking[${index}].GeneralSettingId`, String(shift.generalSettingId))
      formData.append(`WeeklyWorking[${index}].ShiftDescriptionAr`, shift.shiftDescriptionAr)
      formData.append(`WeeklyWorking[${index}].ShiftDescriptionEn`, shift.shiftDescriptionEn)
      formData.append(`WeeklyWorking[${index}].TimeFrom`, String(shift.timeFrom))
      formData.append(`WeeklyWorking[${index}].TimeTo`, String(shift.timeTo))
    })

    return axios.post(url, formData)
  },

  // PWA About Us APIs
  getPWAAboutUs(): Promise<ListResponse<GetTermAndConditionResponse>> {
    const url = `${API_URL}/api/v1/pwa-about-us/get-item`
    return axios.get(url)
  },
  savePWAAboutUs(params: AboutUsRequest): Promise<ListResponse<any>> {
    const url = `${API_URL}/api/v1/pwa-about-us/save`
    return axios.post(url, params)
  },

  // PWA Term and condition APIs
  getPWATermAndCondition(): Promise<ListResponse<GetTermAndConditionResponse>> {
    const url = `${API_URL}/api/v1/pwa-term-and-conditon/get-item`
    return axios.get(url)
  },
  savePWATermAndCondition(params: TermAndConditionRequest): Promise<ListResponse<any>> {
    const url = `${API_URL}/api/v1/pwa-term-and-conditon/save`
    return axios.post(url, params)
  },

  // PWA Banner APIs
  uploadBanner(data: any): Promise<ListResponse<any>> {
    const url = `${API_URL}/api/v1/pwa/banners/upload`
    return axios.post(url, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  deleteBanner(id: number): Promise<Response<boolean>> {
    const url = `${API_URL}/api/v1/pwa/banners/${id}`;
    return axios.delete(url);
  },

  // PWA Card APIs
  getPwaCard(): Promise<Response<PwaCardQry>> {
    const url = `${API_URL}/api/v1/pwa-card/get-item`
    return axios.get(url)
  },

  // Upload image file separately
  uploadImage(file: File): Promise<Response<{ fileUrl: string }>> {
    const url = `${API_URL}/api/v1/upload/image` // Generic upload endpoint
    const formData = new FormData()
    formData.append('file', file)

    return axios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  savePwaCard(payload: PwaCardSaveRequest): Promise<Response<boolean>> {
    const url = `${API_URL}/api/v1/pwa-card/save`

    const formData = new FormData()
    
    formData.append('Id', String(payload.id || 0))
    formData.append('CompanyId', payload.companyId || '')
    formData.append('SectionTitleEn', payload.sectionTitleEn)
    formData.append('SectionTitleAr', payload.sectionTitleAr)
    
    payload.features.forEach((feature, index) => {
      formData.append(`Features[${index}].Id`, String(feature.id || 0))
      formData.append(`Features[${index}].CardId`, String(payload.cardId || 0))
      formData.append(`Features[${index}].TitleEn`, feature.titleEn)
      formData.append(`Features[${index}].TitleAr`, feature.titleAr)
      formData.append(`Features[${index}].DescriptionEn`, feature.descriptionEn)
      formData.append(`Features[${index}].DescriptionAr`, feature.descriptionAr)
      
      if (feature.image) {
        formData.append(`Features[${index}].Image`, feature.image)
      }
    })

    console.log('FormData being sent for PWA Card:')
    console.log('Features count:', payload.features.length)
    payload.features.forEach((feature, index) => {
      console.log(`Feature ${index}:`, {
        id: feature.id,
        hasImage: !!feature.image,
        titleEn: feature.titleEn,
        titleAr: feature.titleAr
      })
    })

    return axios.post(url, formData)
  },
}

export default SettingApi
